import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/impressum',
      name: 'impressum',
      component: () => import('./views/Impressum.vue')
    },
    {
      path: '/anfahrt',
      name: 'journey',
      component: () => import('./views/Journey.vue')
    },
    {
      path: '/karte',
      name: 'areaMap',
      component: () => import('./views/AreaMap.vue')
    },
    {
      path: '/stand1',
      name: 'booth1',
      component: () => import('./views/Booth1.vue')
    },
    {
      path: '/stand2',
      name: 'booth2',
      component: () => import('./views/Booth2.vue')
    },
    {
      path: '/stand3',
      name: 'booth3',
      component: () => import('./views/Booth3.vue')
    },
    {
      path: '/stand4',
      name: 'booth4',
      component: () => import('./views/Booth4.vue')
    }
  ]
})
